import { Injectable } from '@angular/core';
import { Actions, Effect, toPayload } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Auth, AuthState } from '@shared/auth';
import { ActionType, WebsocketActionPayload } from '../actions';
import { pluckListItemFromRawStore, RawStoreState } from '../helpers';
import { WebsocketNewMessageEvent } from '../websocket/server-message-event.model';

@Injectable()
export class MessagesEffect {
  @Effect()
  fetchData = this.actions
    .ofType('WS_MESSAGE')
    .map<Action, WebsocketActionPayload>(toPayload)
    .filter(isMessagesPrivatePayload)
    .withLatestFrom(this.store, this.auth.authState)
    .do(([wsMessage, state, auth]) => {
      if ((<any>window).liveChat) {
        (<any>window).liveChat.startChat(
          [],
          undefined,
          'websocket',
          undefined,
          wsMessage.data.thread_id,
          false,
        );
      }
    })
    .filter(
      ([wsMessage, state, auth]) =>
        !!auth &&
        !pluckListItemFromRawStore(
          state,
          ['threads', auth.userId],
          wsMessage.data.thread_id,
        ),
    )
    .map(([wsMessage, state, auth]) => {
      const action: ActionType<'threads'> = {
        type: 'REQUEST_DATA',
        payload: {
          type: 'threads',
          ref: { path: ['threads', (<AuthState>auth).userId] },
          query: { params: { 'threads[]': wsMessage.data.thread_id } },
        },
      };
      return action;
    })
    .mergeMap(action => [action, { type: '_MISSING_THREAD_FETCHING_' }]);

  constructor(
    private actions: Actions,
    private auth: Auth,
    private store: Store<RawStoreState>,
  ) {}
}

function isMessagesPrivatePayload(
  p: WebsocketActionPayload,
): p is WebsocketNewMessageEvent & { toUserId: string } {
  return p.type === 'private' && p.parent_type === 'messages';
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/@shared/datastore/message/messages.effect.ts